import {GET_MESSAGES, SELECT_ALL_MESSAGES, UNSELECT_ALL_MESSAGES} from "../types";

export const unselectMessages = () => dispatch => dispatch({ type: UNSELECT_ALL_MESSAGES,  payload: [] });

export const selectAllMessages = (messages) => dispatch => dispatch({type: SELECT_ALL_MESSAGES, payload: messages});

export const getMessages = (messages) => dispatch => dispatch({ type: GET_MESSAGES, payload: messages});

